import { createContext } from 'react';

const PadViewContext = createContext({});

export default PadViewContext;
